module.exports = __webpack_public_path__ + "static/media/Thumbs.f5d24230.db";